/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown> }} Audio_Embed_Export_Stream_SubtitleInputs */



/**
* | output |
* | --- |
* | "Subtitle {index}: {codec}" |
*
* @param {Audio_Embed_Export_Stream_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_subtitle = /** @type {((inputs: Audio_Embed_Export_Stream_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sous-titre ${i?.index}: ${i?.codec}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Untertitel ${i?.index}: ${i?.codec}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sottotitolo ${i?.index}: ${i?.codec}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Субтитры ${i?.index}: ${i?.codec}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Subtítulo ${i?.index}: ${i?.codec}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`字幕 ${i?.index}: ${i?.codec}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`字幕 ${i?.index}: ${i?.codec}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपशीर्षक ${i?.index}: ${i?.codec}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Legenda ${i?.index}: ${i?.codec}`)
	return /** @type {LocalizedString} */ (`Subtitle ${i?.index}: ${i?.codec}`)
});